import { CATEGORY_PAGE, CategoryPageLayoutType, PRODUCT_PAGE, ProductPageLayoutType, WIDGET_IDS } from '@wix/a11y-rules';
export function getCurrentLayoutName(widgetId, layoutValue) {
  const isProductPage = widgetId === WIDGET_IDS.PRODUCT_PAGE;
  const isCategoryPage = widgetId === WIDGET_IDS.CATEGORY_PAGE;
  const currentLayoutValue = layoutValue ?? (isProductPage ? PRODUCT_PAGE.defaultValue : isCategoryPage ? CATEGORY_PAGE.defaultValue : 0);
  if (isProductPage) {
    return ProductPageLayoutType[currentLayoutValue] || `Layout ${currentLayoutValue}`;
  }
  if (isCategoryPage) {
    return CategoryPageLayoutType[currentLayoutValue] || `Layout ${currentLayoutValue}`;
  }
  return 'Unknown';
}
export function getRecommendedLayoutName(widgetId) {
  const isProductPage = widgetId === WIDGET_IDS.PRODUCT_PAGE;
  const isCategoryPage = widgetId === WIDGET_IDS.CATEGORY_PAGE;
  if (isProductPage) {
    const recommendedLayoutValue = PRODUCT_PAGE.accessibleValue;
    return ProductPageLayoutType[recommendedLayoutValue];
  }
  if (isCategoryPage) {
    const recommendedLayoutValue = CATEGORY_PAGE.accessibleValue;
    return CategoryPageLayoutType[recommendedLayoutValue];
  }
  return 'Unknown';
}
export function getPageType(widgetId) {
  const isProductPage = widgetId === WIDGET_IDS.PRODUCT_PAGE;
  const isCategoryPage = widgetId === WIDGET_IDS.CATEGORY_PAGE;
  return isProductPage ? 'Product' : isCategoryPage ? 'Category' : 'Page';
}
//# sourceMappingURL=layout-utils.js.map